import companyCenter from './companyCenter.reducer';

const reducer = {
  companyCenter,
};

export default reducer;
